import client from './graphQlClient';
import { SEARCH_OWNER } from './queries/CompanyQueries';
export class OwnersApi {
    static search = (name, cancelToken) => {
        return new Promise((resolve, reject) => {
            client()
                .query({
                    query: SEARCH_OWNER,
                    fetchPolicy: 'no-cache',
                    variables: {
                        search: name,
                    },
                })
                .then((result) => {
                    resolve(result.data.owners);
                });
            cancelToken.promise.then((reason) => {
                reject(reason);
            });
        });
    };
}
